import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import queryString from 'query-string';

import ListButtonsGroup from 'components/base/ListButtonsGroup';

import AuthButton from '../../../components/base/AuthButton';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import DeletePrompt from '../../../components/base/DeletePrompt';
import { DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';
import { NavBarNames } from '../../../config/NavBarNameList';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { ArrayStringData, createAction } from '../../../utils';
import BaseListContainer from '../../base/BaseListContainer';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import SettingDefaultMallPrompt from './SettingDefaultMallPrompt';

import './MallList.scss';

function MallList({
  listFields,
  dataList,
  pageInfo,
  totalPage,
  totalCount,
  checkedList,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [showSetting, setShowSetting] = useState(false);

  const buttons = [
    <ListButtonsGroup
      hideExtraButtonWidth={800}
      hideAllButtonWidth={530}
      primaryButton={
        <AuthButton
          title="Create Mall"
          action={() => {
            history.push('/mall/create');
          }}
          requires={PermissionCodes.addMall}
        />
      }
      // extraButtons={[
      //   <AuthButton
      //     customClass="btn-back-button-common btn-download"
      //     title="Setting default mall"
      //     action={() => {
      //       setShowSetting(true);
      //     }}
      //     requires={PermissionCodes.viewMall}
      //   />,
      // ]}
      // extraPopContent={[
      //   {
      //     requires: [PermissionCodes.viewMall],
      //     action: () => {
      //       setShowSetting(true);
      //     },
      //     content: 'Setting default mall',
      //   },
      // ]}
    />,
  ];

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.deleteMall,
    },
  ];

  const tabs = [
    {
      name: 'List of Malls',
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{
            hasFilter: false,
            // component: Filter,
          }}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'mall'}
              permissionGroup={PermissionCodes.mall}
              deleteInfo={{
                data: [],
                title: 'mall',
                relatedName: '',
                onComfirm: {},
                relatedSections: null,
              }}
              actions={['Edit', 'Delete', 'Duplicate']}
            />
          }
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch({ type: 'mall/clearData' });

    const queryString = require('query-string');
    if (queryString) {
      const querySearch = queryString.parse(location.search);
      const searchKey = querySearch['search'] || '';
      const stringRank = querySearch['rank'] || 'true';
      const stringPage = querySearch['page'] || 1;
      const rank = stringRank === 'true';
      const page = parseInt(stringPage);
      dispatch({
        type: 'mall/getPagedMallList',
        payload: {
          ...querySearch,
          page,
          reverse: rank,
          search: searchKey,
          isListNode: true,
        },
      });
    }
  }, [dispatch, location]);

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: NavBarNames.mall,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={false}
      />
      <DeletePrompt
        data={checkedList}
        title={'malls'}
        relatedName={''}
        relatedSections={[]}
        show={showDeletePrompt}
        onClose={() => setShowDeletePrompt(false)}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch({
            type: 'mall/delete',
            payload: {
              afterAction: () => {
                history.push(location);
              },
            },
          });
        }}
      />
      <SettingDefaultMallPrompt show={showSetting} setShow={setShowSetting} />
    </>
  );
}

const mapPropsToState = (state) => ({
  listFields: state.mall.listDisplayFields,
  dataList: state.mall.pagedMallList,
  pageInfo: state.mall.pageInfo,
  totalPage: state.mall.totalPage,
  totalCount: state.mall.totalCount,
  checkedList: state.mall.checkedList,
});

export default connect(mapPropsToState)(MallList);
